<div class="ua-wrap" [style.background]="(imageUrl && !imageError) ? 'transparent' : color" aria-hidden="true">
  @if (imageUrl && !imageError) {
    <img [src]="imageUrl" [alt]="name + ' avatar'" class="ua-img" (error)="onImageError()" />
  } @else {
    <span class="ua-initials">{{ initials }}</span>
  }
</div>